import { useMemo } from "react";

export const useTitleByMethod = (selectedItem: any) => {
  const title: string = useMemo(() => {
    if (selectedItem) {
      switch (selectedItem.methodType) {
        case 1:
          return "Bank Account";
        case 2:
          return "Card";
        default:
          return "";
      }
    }

    return "";
  }, [selectedItem]);

  return { title };
};
